import { DOCUMENT, Injectable, inject } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LinkService {
	private dom: Document = inject(DOCUMENT);

	updateCanonicalUrl(url: string): void {
		const head = this.dom.getElementsByTagName('head')[0];
		let element: HTMLLinkElement | null = this.dom.querySelector(`link[rel='canonical']`) || null;

		if (element === null) {
			element = this.dom.createElement('link') as HTMLLinkElement;
			head.appendChild(element);
		}

		element.setAttribute('rel', 'canonical');
		element.setAttribute('href', url);
	}
}
